export default __webpack_public_path__ + "static/media/sba-report-card.11949b03.jpg";